import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  Grid,
  Box,
} from "@mui/material";
import {
  deleteEmployeeDocument,
  postUploadJoiningDocument,
} from "../../api/employee";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import { CloudUpload } from "@mui/icons-material";
import EmployeeDocuments from "../employees/employee.documents";

export default function FileUploadComponent({ documentTypeData }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [refreshCount, setRefreshCount] = useState(0);
  const [documentType, setDocumentType] = useState(documentTypeData);
  const [open, setOpen] = useState(false);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
  };

  const handleDocumentTypeChange = (e) => {
    setDocumentType(e.target.value);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    try {
      formData.append("document_types", documentTypeData);
      const { data } = await postUploadJoiningDocument(formData, user.token);
      setRefreshCount((prevCount) => prevCount + 1);
      dispatch(showAlert(data.msg));
      setDocumentType("");

      setOpen(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  useEffect(() => {
    setRefreshCount((prevCount) => prevCount + 1);
    console.log("triggered useefeexct");
  }, [documentTypeData]);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = async (id) => {
    try {
      const { data } = await deleteEmployeeDocument(id, user.token);
      setRefreshCount((prevCount) => prevCount + 1);
      dispatch(showAlert(data.msg));
      setDocumentType("");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  return (
    <Box>
      <Box
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          style={{ margin: 10 }}
          onClick={handleOpen}
          variant="contained"
          color="primary"
        >
          Upload
        </Button>
      </Box>

      <EmployeeDocuments
        id={user.roleId}
        refreshCount={refreshCount}
        documentTypes={documentTypeData}
        setRefreshCount={setRefreshCount}
        handleDelete={handleDelete}
      />

      <Dialog
        open={open}
        onClose={() => {
          // setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ textTransform: "capitalize" }}
        >
          {documentTypeData}
        </DialogTitle>
        <DialogContent>
          <Grid container width={500} spacing={1} py={1}>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                disabled
                fullWidth
                label="Document Type"
                value={documentTypeData}
                onChange={handleDocumentTypeChange}
                multiline={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Card sx={{ boxShadow: "none !important" }}>
                <div class="upload-files-container">
                  <div class="drag-file-area">
                    <div class="upload-icon">
                      <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                    </div>
                    <h6 class="dynamic-message"> Drag & drop any file here </h6>
                    <div class="browse-files">
                      <input type="file" onChange={handleFileChange} multiple />
                      {/* {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModifiedDate:{" "}
                          {selectedFile.lastModifiedDate.toLocaleDateString()}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )} */}
                    </div>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="blue-button" onClick={handleUpload}>
            Upload
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
